"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const actions_1 = require("../context/actions");
const constants_1 = require("../data/constants");
const math_1 = require("./math");
const fiatRates_1 = require("./fiatRates");
const setCryptoValue = (dispatch, cryptoCode, fiatCode, baseFiatRate) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const convertedBaseRate = Math.round(constants_1.DEFAULT_FIAT_AMOUNT * baseFiatRate);
        const rounded = (0, math_1.roundUp)(convertedBaseRate, Math.pow(10, (convertedBaseRate.toString().length - 1)));
        const res = yield (0, fiatRates_1.convertFiatRate)(cryptoCode, fiatCode || constants_1.DEFAULT_FIAT_CODE, rounded);
        const prcision = Number(res.toFixed(8));
        dispatch({ type: actions_1.CONTEXT_ACTIONS.SET_CRYPTO_VALUE, payload: prcision });
    }
    catch (error) {
        console.log("error getting base crypto", error);
    }
});
exports.default = setCryptoValue;
//# sourceMappingURL=setCryptoValue.js.map